// @ts-nocheck
import React from 'react';
import {
  Home,
  Terms,
  ProposaList,
  CustomTerms,
  SelfieTips,
  Selfie,
  SucessSelfie,
  SignRetentionSignature,
  FinishRetention,
  RetentionReason,
  ProposaListRetention,
} from './index';

interface IStepDisplay {
  formValues: Signature;
  currentStep: number;
  isRetention?: boolean;
}

const RetentionStepsDisplay = ({ currentStep, formValues }: IStepDisplay) => {
  switch (currentStep) {
    case 1:
      return <Home isRetention />;
    case 2:
      return <Terms formValues={formValues} isRetention />;
    case 3:
      return <ProposaListRetention formValues={formValues} />;
    case 4:
      return <RetentionReason formValues={formValues} />;
    case 5:
      return <SelfieTips isRetention />;
    case 6:
      return <Selfie formValues={formValues} isRetention />;
    case 7:
      return <SucessSelfie formValues={formValues} isRetention />;
    case 8:
      return <FinishRetention />;
    default:
      return null;
  }
};

export default RetentionStepsDisplay;
